<template>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#gateway_list"
                           @click="gotoTab(1)">
                            {{ $t('deposit.gateway_list') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{ name: 'deposit_accounts', gateway_source : gateway_source}" class="nav-link">
                        {{ $t('deposit.accounts') }}
                        </router-link>
                    </li>
<!--                    <li class="nav-item">-->
<!--                        <a :class="['nav-link', currentTab === 3 ? 'active' : '']" href="#accounts_general_setting"-->
<!--                           @click="gotoTab(3)">-->
<!--                            {{ $t('deposit.accounts_general_setting') }}-->
<!--                        </a>-->
<!--                    </li>-->
                    <li class="nav-item">
                        <router-link :to="{ name: 'deposit_requests', gateway_source : gateway_source}" class="nav-link">
                            {{ $t('deposit.requests') }}
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="$can('run-deposit-with-id-schedule', 'tech-support')">
                        <a :class="['nav-link', currentTab === 4 ? 'active' : '']" href="#get_deposit_manually"
                           @click="gotoTab(4)">
                            {{ $t('deposit.get_deposit_manually') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div :class="['tab-pane', currentTab === 1 ? 'active' : '']" id="#gateway_list">
                    <div style="margin-top: 15px" id="gateway_list" aria-labelledby="gateway_list"
                         data-parent="#gateway_list">
                        <deposit-filter :action="filterAction"></deposit-filter>
                        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
                    </div>
                </div>
            </div>
<!--            <div class="tab-content">-->
<!--                <div :class="['tab-pane', currentTab === 3 ? 'active' : '']" id="#accounts_general_setting">-->
<!--                    <div style="margin-top: 15px" id="accounts_general_setting"-->
<!--                         aria-labelledby="accounts_general_setting"-->
<!--                         data-parent="#accounts_general_setting">-->
<!--                        <general-settings></general-settings>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="tab-content" v-if="$can('run-deposit-with-id-schedule', 'tech-support')">
                <div :class="['tab-pane', currentTab === 4 ? 'active' : '']" id="#get_deposit_manually">
                    <div style="margin-top: 15px" id="get_deposit_manually"
                         aria-labelledby="get_deposit_manually"
                         data-parent="#get_deposit_manually">
                        <get-deposit-manually></get-deposit-manually>
                    </div>
                </div>
            </div>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
import columns from './../datatable/columns'
import {ApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import actionsColumn from './actions-column'
import depositFilter from './deposit-filter'
import generalSettings from './general-settings'
import getDepositManually from './get-deposit-manually-form.vue'
import {StarShopApiUrl} from "../../../common/api.service";

export default {

    components: {
        'deposit-filter': depositFilter,
        // 'general-settings': generalSettings,
        'get-deposit-manually': getDepositManually,
    },
    data() {
        return {
            query: {},
            currentTab: 1,
            gateway_source: 'starshop'
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "deposit_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: StarShopApiUrl.path('open-banking/deposit/admin'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        gotoTab(index) {
            this.currentTab = index;
        }
    }
}
</script>

<style>

</style>